import { Component, OnInit, ViewContainerRef } from '@angular/core'
import { NzModalService } from 'ng-zorro-antd/modal'
import { QueryTableLeave } from 'src/app/services/interface/general.model'
import { NzTableQueryParams } from 'ng-zorro-antd/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AddAnnualLeaveComponent } from './add-annual-leave/add-annual-leave.component'
import { AnnualLeaveType } from 'src/app/services/interface/leave-management/leave.model'
import { LeaveManagementService } from 'src/app/services/leave-management/leave-management.service'

@Component({
  selector: 'app-annual-leave',
  templateUrl: './annual-leave.component.html',
  styleUrls: ['./annual-leave.component.scss'],
})
export class AnnualLeaveComponent implements OnInit {
  isAnnualLeave = true
  selectedFilter = 'WAITING'
  selectedType = 'Annual Leave'

  listOfData: AnnualLeaveType[] = []

  isLoading: boolean = true
  totalData: number = 0
  pageSize: number = 5
  pageIndex: number = 1

  annualQuotaLeave = null
  collectiveQuotaLeave = null

  form: FormGroup
  constructor(
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
    private leaveManagementService: LeaveManagementService,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      keyword: [null, Validators.compose([Validators.required])],
      prefix: ['vendor', Validators.compose([Validators.required])],
    })
  }

  queryTable: QueryTableLeave = {
    sort: { field: null, order: null },
    annual_leave: true,
    pageSize: this.pageSize,
    pageIndex: this.pageIndex - 1,
  }

  ngOnInit(): void {
    this.checkQuotaLeave()
  }

  fetchAnnualLeaveList() {
    this.isLoading = true
    this.leaveManagementService
      .getAnnualLeaveList(
        this.selectedFilter,
        this.queryTable,
        this.isAnnualLeave,
        this.selectedType,
      )
      .subscribe((r: any) => {
        this.isLoading = false
        this.listOfData = r.rows
        this.totalData = r.count
      }),
      err => {
        this.fetchAnnualLeaveList()
      }
  }

  checkQuotaLeave() {
    this.isLoading = true
    this.leaveManagementService.checkQuotaLeave().subscribe((r: any) => {
      this.isLoading = false
      this.annualQuotaLeave = r.annual_leave_quota
      this.collectiveQuotaLeave = r.collective_leave_quota
    })
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params
    this.queryTable.pageSize = pageSize
    this.queryTable.pageIndex = pageIndex - 1
    const currentSort = sort.find(item => item.value !== null)
    const sortField = (currentSort && currentSort.key) || null
    const sortOrder = (currentSort && currentSort.value) || null

    if (sortField != null && sortOrder != null) {
      this.queryTable.sort = {
        field: sortField,
        order: sortOrder,
      }
    } else {
      this.queryTable.sort = { field: null, order: null }
    }
    this.fetchAnnualLeaveList()
  }

  reset() {
    this.form.reset()
    this.form.patchValue({ prefix: 'name' })
    this.queryTable.sort = null

    this.fetchAnnualLeaveList()
  }

  addLeave() {
    const modal = this.modal.create({
      nzTitle: 'Form Annual Leave',
      nzContent: AddAnnualLeaveComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzComponentParams: {},
      nzMaskClosable: false,
      nzClosable: false,
      nzOkText: 'Submit',
      nzOkDisabled: true,
      nzOnOk: () => {
        const instance = modal.getContentComponent()
        instance.submitForm()
      },
      nzWidth: '75%',
    })
    const instance = modal.getContentComponent()
    modal.afterClose.subscribe(() => {
      this.fetchAnnualLeaveList()
    })
  }
}
